import { inject, Injectable } from '@angular/core';
import { IqTrendlinesOptimizelyService } from './iq-trendlines-optimizely.service';

declare var analytics: any;

@Injectable({
    providedIn: 'root',
})
export class IqTrendlinesSegmentTrackingService {
    private _optimizelyService: IqTrendlinesOptimizelyService = inject(
        IqTrendlinesOptimizelyService,
    );
    constructor() {}
    register() {
        const userId = this._optimizelyService.getVisitorId();
        analytics.identify(userId, {});
    }

    track(event: string, props = {}) {
        if (analytics) {
            analytics.track(event, props);
        } else {
            console.warn(
                'Analytics not initialized or track method not available',
            );
        }
    }
}
